import InputLabel from 'components/others/InputLabel';
import AccessUserRole from './AccessFields/AccessUserRole';
import { useTranslation } from 'react-i18next';
import UserTabAccessManager from './UserTabAccessManager';
import UserTabAccessExecutor from './UserTabAccessExecutor';
import type { UserTabProps } from '../../types';

const UserTabAccess = ({ user, dispatchUser }: UserTabProps) => {
    const { t } = useTranslation();

    return (
        <>
            <InputLabel title={t('Users.accessRole')} rightElement={null}>
                <AccessUserRole user={user} dispatchUser={dispatchUser} />
            </InputLabel>

            {user?.access?.role == 'manager' && <UserTabAccessManager user={user} dispatchUser={dispatchUser} />}

            {user?.access?.role == 'executor' && <UserTabAccessExecutor user={user} dispatchUser={dispatchUser} />}
        </>
    );
};

export default UserTabAccess;
